// VST-87223 - temporary until manage work is complete and add pill back
import { useIntl } from "react-intl";
import { useMemo } from "react";
import {
  PopoverLink,
  PopoverLinkDescriptor,
} from "routes/home/common/cards/usePopoverLinks";

const descriptor: PopoverLinkDescriptor = "accessibility-claims";

export default function useAccessibilityClaimsLink(
  onClick?: () => void
): PopoverLink {
  const intl = useIntl();

  return useMemo(() => {
    return {
      label: intl.formatMessage({ defaultMessage: "Accessibility Claims" }),
      onClick,
      descriptor,
    };
  }, [intl, onClick]);
}
